
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.584 17.417h15.833","stroke":"#FF9F43","stroke-width":"1.125","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.336 17.417l.04-9.524c0-.483.23-.942.61-1.243l5.54-4.315a1.592 1.592 0 011.948 0l5.542 4.307c.388.3.61.76.61 1.25v9.525","stroke":"#FF9F43","stroke-width":"1.125","stroke-miterlimit":"10","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.27 8.709H6.73c-.658 0-1.188.53-1.188 1.187v7.521h7.917v-7.52c0-.658-.53-1.188-1.188-1.188zM7.916 12.864v1.188M8.313 5.938h2.374","stroke":"#FF9F43","stroke-width":"1.125","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    